export default __webpack_public_path__ + "static/media/header.f7803bf8.png";